// src/stores/user.store.ts
import { create } from "zustand";
import type { UserData } from "../models/user.model.ts";
import type { CurrencyType } from "../models/booking.model.ts";
import { identifyUser, resetUser } from "../utils/posthog.ts";
import { useCurrencyStore } from "./currency.store.ts";

type UserState = {
  user: UserData | null;
  setUser: (user: UserData | null) => void;
  clearUser: () => void;
  hydrateFromStorage: () => void;
};

const USER_KEY = "korehalal_user";

export const userStore = create<UserState>((set) => ({
  user: null,

  setUser: (user) => {
    set({ user });
    identifyUser(user);
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
    else localStorage.removeItem(USER_KEY);
    // 계정 통화를 표시 통화로 — 로그인 직후 홈 조회가 이 브라우저에 남은 이전 통화로
    // 나가 «Rp89»(USD 금액 + IDR 기호)가 됐다. 로그인 경로가 많아 여기 한 곳에서 맞춘다.
    if (user?.currency) useCurrencyStore.getState().setCurrency(user.currency as CurrencyType);
  },

  clearUser: () => {
    set({ user: null });
    resetUser();
    localStorage.removeItem(USER_KEY);
  },

  hydrateFromStorage: () => {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return;
    try {
      const parsed = JSON.parse(raw) as UserData;
      set({ user: parsed });
      identifyUser(parsed);
    } catch {
      localStorage.removeItem(USER_KEY);
      set({ user: null });
    }
  },
}));
